/* eslint-disable no-unused-vars */
import React from 'react';
import Loadable from 'react-loadable';
import CoreException from './Error';
import { Loading } from '../components/Loading';
import routesConfig from './routesConfig.json';

const getComponent = loader => ({
  loader,
  loading: props => {
    if (props.error) {
      return <CoreException desc={props.error.toString()} />;
    } else if (props.timedOut) {
      return (
        <CoreException
          desc="页面加载超时"
          onBtnClick={() => {
            window.location.reload();
          }}
          btnText="点我重试"
        />
      );
    } else if (props.pastDelay) {
      return <Loading />;
    }
    return null;
  }
});
// 路由
const routes = [
  ...routesConfig.map(item => ({
    ...item,
    component: Loadable(
      getComponent(() => {
        return import(`pages/${item.path.replace('/', '')}/index.jsx`);
      })
    )
  })),
  {
    path: '*',
    title: '抱歉，您访问的页面不存在！',
    component: require('core/Error/404').default
  }
];

const finalRouters = routes.map(route => {
  return {
    ...route,
    exact: true,
    strict: true
  };
});

export default finalRouters;
